export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "AddressIndexWorker.e6ae3ecc37d4bfb32d0e.worker.js");
}
